import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchObtenerCategoriasPublicaciones = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/comunicacion/categorias`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchObtenerCategoriaPublicacion = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/comunicacion/categorias/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchCrearCategoriaPublicacion = async (categoriaData) => {
    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/categorias`, categoriaData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchActualizarCategoriaPublicacion = async (id, categoriaData) => {
    try {
        const response = await axios.put(`${API_URL}/api/comunicacion/editarCategorias/${id}`, categoriaData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchEliminarCategoriaPublicacion = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/comunicacion/categorias/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchCategoriasPublicacionFilters = async (paginaActual, registrosPorPag, busqueda, ordenarColumna, orden) => {

    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/categorias/filters`, {

            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }

        }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });


        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEliminarCategoriasPublicaciones = async (ids) => {
    console.log(ids)
    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/actualizarCategoriasEnCadena`, {
            ids: ids,
        }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchActualizarCategoriasPublicaciones = async (ids, campoValor) => {
    console.log("campoValor", campoValor);
    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/actualizarCategoriasEnCadena`, {
            ids: ids,
            campo: campoValor.atributo,
            valor: campoValor.valor
        }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};